import * as React from "react";

export const IconActionStar = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_30902_33261)">
      <path
        d="M11.99 2.5C6.47 2.5 2 6.98 2 12.5C2 18.02 6.47 22.5 11.99 22.5C17.52 22.5 22 18.02 22 12.5C22 6.98 17.52 2.5 11.99 2.5ZM16.23 18.5L12 15.95L7.77 18.5L8.89 13.69L5.16 10.46L10.08 10.04L12 5.5L13.92 10.03L18.84 10.45L15.11 13.68L16.23 18.5Z"
        fill="#48A0B2"
      />
    </g>
    <defs>
      <clipPath id="clip0_30902_33261">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
